import { render, staticRenderFns } from "./ElectricReport.vue?vue&type=template&id=65854a9f"
import script from "./ElectricReport.vue?vue&type=script&lang=js"
export * from "./ElectricReport.vue?vue&type=script&lang=js"
import style0 from "./ElectricReport.vue?vue&type=style&index=0&id=65854a9f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports